import { useQuery } from '@tanstack/react-query';
import { SitesService } from 'src/services/sites/sites.service';

export const useSiteTags = (
  customerId: string,
  siteId: string,
  enabled?: boolean,
  displayName: string | null = null
) =>
  useQuery({
    queryKey: ['siteTags', customerId, siteId, displayName],
    queryFn: () => SitesService.getTags(customerId, siteId, displayName),
    staleTime: 1000 * 60 * 2, // 2 min cache
    enabled,
  });
